import { appThemes } from '../constants/appThemes';

export const getTinyMCEEditorTheme = () => {
  const appTheme = +window.ncReactThemesConfiguration['currentAppTheme'];

  switch (appTheme) {
    case appThemes.Primary:
    case appThemes.Secondary:
    case appThemes.Third:
    case appThemes.Indigo:
    case appThemes.Ocean:
    case appThemes.Platinum:
      return {};
    case appThemes.Dark:
    case appThemes.Night:
      return {
        skin: 'oxide-dark',
        content_css: 'dark',
      };
    default:
      return {};
  }
};
